<template>
  <el-tooltip
    :content="`<span class='color-info fw-bold'>${tooltipText}</span>`"
    effect="light"
    :raw-content="true"
    :auto-close="1000"
    :disabled="isDisabled"
  >
    <div
      :class="`${isDisabled ? '' : 'icon-button cursor-pointer'} color-${
        isDisabled ? 'gray' : iconColor
      } ${includePadding ? 'px-sm-2 px-1' : ''}  `"
      @click.stop="onIconClicked"
    >
      <i :class="`bi bi-${iconName} fs-${iconSize}`"></i>
    </div>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "IconTooltipButton",
  props: {
    iconName: { type: String, required: true },
    iconColor: { type: String, default: "info" },
    iconSize: { type: String, default: "s" },
    tooltipText: { type: String, required: true },
    includePadding: { type: Boolean, default: true },
    isDisabled: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    function onIconClicked() {
      emit("onClick");
    }
    return { onIconClicked };
  },
});
</script>

<style lang="scss" scoped>
.icon-button:hover {
  color: $color-info-dark;
}
</style>
